export const decodeBase64 = (b64) => {
  try {
    return Uint8Array.from(atob(b64), (b) => b.charCodeAt(0));
  } catch (e) {
    console.error(e);
    throw new Error("Invalid base64 string");
  }
};
export const encodeBase64 = (b) => {
  try {
    return btoa(Array.from(b, (byte) => {
      return String.fromCodePoint(byte);
    }).join(""));
  } catch (e) {
    console.error(e);
    throw new Error("Invalid Uint8Array");
  }
};
export const decodeHex = (s) => {
  const bytes = s.match(/[0-9A-Fa-f]{2}/g);
  if (!bytes) {
    throw new Error("bad hex string");
  }
  return Uint8Array.from(bytes.map((byte) => parseInt(byte, 16)));
};
export const encodeHex = (a) => a.reduce((s, b) => s + b.toString(16).padStart(2, "0"), "");
export function int32ToUint8Array(num) {
  if (num > 2147483647) {
    throw new Error("Number too large");
  }
  return new Uint8Array(new Int32Array([num]).buffer);
}
export function uint8ArrayToInt32(buffer) {
  return new Int32Array(buffer.buffer)[0];
}
export function isEqualUint8Array(bytes1, bytes2) {
  if (bytes1.length !== bytes2.length) {
    return false;
  }
  for (let i = 0; i < bytes1.length; i++) {
    if (bytes1[i] !== bytes2[i]) {
      return false;
    }
  }
  return true;
}
export function parseBytesWithPrefixedLength(bytes) {
  const data = [];
  while (bytes.length > 0) {
    const length = uint8ArrayToInt32(bytes.slice(0, 4));
    if (length < 0 || length > bytes.length - 4) {
      throw new Error("Invalid prefix length data");
    }
    data.push(bytes.slice(4, 4 + length));
    bytes = bytes.slice(4 + length);
  }
  return data;
}
export function encodeBytesWithPrefixedLength(...params) {
  const elements = [];
  for (let i = 0; i < params.length; i++) {
    int32ToUint8Array(params[i].length).forEach((b) => elements.push(b));
    params[i].forEach((b) => elements.push(b));
  }
  return new Uint8Array(elements);
}
